import { request } from '@/plugins/http';

/**
 * 企业树状列表
 * @param params
 * @returns {AxiosPromise}
 */
const getAreaTree = params => request('/area/getAreaTree', params);

/**
 * 添加企业
 * @param params
 * @returns {AxiosPromise}
 */
const addArea = params => request('/area/addArea', params);

/**
 * 企业回显
 * @param params
 * @returns {AxiosPromise}
 */
const getAreaData = params => request('/area/getArea', params);

/**
 * 修改企业
 * @param params
 * @returns {AxiosPromise}
 */
const updateArea = params => request('/area/updateArea', params);

/**
 * 删除企业
 * @param params
 * @returns {AxiosPromise}
 */
const delArea = params => request('/area/delAreas', params);

export {
    getAreaTree,
    addArea,
    delArea,
    getAreaData,
    updateArea,
};
